import { render, staticRenderFns } from "./CustomerRollOut.vue?vue&type=template&id=6b24c405&scoped=true"
import script from "./CustomerRollOut.vue?vue&type=script&lang=js"
export * from "./CustomerRollOut.vue?vue&type=script&lang=js"
import "./CustomerRollOut.vue?vue&type=style&index=0&id=6b24c405&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b24c405",
  null
  
)

export default component.exports